{
  "error-unable-to-create": "Unable to create person. Please try again later",
  "error-unable-to-delete": "Unable to delete person. Please try again later",
  "error-unable-to-update": "Unable to update person. Please try again later",
  "error-unable-to-remove-app-access": "Unable to remove app access. Please try again later",
  "remove-individual-modal-ok": "Remove Individual",
  "remove-individual-modal-title": "Remove Individual?",
  "remove-individual-modal-body": "Removing this person will delete them from your account. Additionally, any assets or debts assigned to them will revert their ownership back to the primary head-of-household. This action cannot be undone.",
  "remove-person-success": "Person successfully removed"
}
